import { AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Warning } from '@styled-icons/ionicons-outline/Warning';
import { BorderedContainer, ThemeTypography } from 'DesignSystem';
import { Accordion } from 'DesignSystem/DataDisplay/Accordion/Accordion';
import React, { FC } from 'react';
import { EDisclaimerTarget } from 'FeatureModules/Request/types/impactClaim.types';
import FlexBox from 'Components/FlexBox';

const StyledWarning = styled(Warning)(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  color: theme.palette.primary.main,
}));

interface IClaimDisclaimer {
  renderedOn?: EDisclaimerTarget;
}

const ClaimDisclaimer: FC<IClaimDisclaimer> = ({
  renderedOn = EDisclaimerTarget.SELECT_CLAIM_SLIDE,
}: IClaimDisclaimer) => {
  const isRenderedOnSelectSlide = renderedOn === EDisclaimerTarget.SELECT_CLAIM_SLIDE;

  const title = 'Regulatory notice';
  const description =
    'By submitting this claim, you confirm that the information and supporting documentation are accurate, complete, current and applicable to the selected level, and that any relevant conditions and usage rights are fulfilled. Submission does not guarantee publication; the claim must first be verified and approved.';

  if (isRenderedOnSelectSlide) {
    return (
      <Accordion transparent>
        <AccordionSummary>
          <FlexBox>
            <StyledWarning size={16} />
            <Box mr={1} />
            <ThemeTypography variant="BODY_LARGE_BOLD" color="GRAY">
              {title}
            </ThemeTypography>
          </FlexBox>
        </AccordionSummary>
        <AccordionDetails>
          <ThemeTypography variant="BODY_LARGE">{description}</ThemeTypography>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <BorderedContainer>
      <FlexBox mb={1}>
        <StyledWarning size={16} />
        <Box mr={1} />
        <ThemeTypography variant="BODY_LARGE_BOLD" color="GRAY">
          {title}
        </ThemeTypography>
      </FlexBox>
      <ThemeTypography variant="BODY_LARGE">{description}</ThemeTypography>
    </BorderedContainer>
  );
};

export default ClaimDisclaimer;
